const optionsData = [
    {
        prod: 'Hambúrguer Simples',
        cat: 'sanduíches',
    },
    {
        prod: 'X-Tudo',
        cat: 'sanduíches',
    },
    {
        prod: 'Mega Paulistão',
        cat: 'sanduíches',
    },
    {
        prod: 'Especial 3 Carnes',
        cat: 'sanduíches',
    },
    {
        prod: 'Natural Vegetal',
        cat: 'sanduíches',
    },
    {
        prod: 'Sanduíche Gelado',
        cat: 'sanduíches',
    },
    {
        prod: 'O Melhor do Mundo',
        cat: 'sanduíches',
    },
    {
        prod: 'Super Boi',
        cat: 'sanduíches',
    },
    {
        prod: 'Salmão no Pão',
        cat: 'sanduíches',
    },
    {
        prod: 'Hambúrguer Vegetariano',
        cat: 'sanduíches',
    },
    {
        prod: 'Hambúrguer de Frango',
        cat: 'sanduíches',
    },
    {
        prod: 'X-EGG',
        cat: 'sanduíches',
    },
    {
        prod: 'Carne Dupla',
        cat: 'sanduíches',
    },
    {
        prod: 'Especial da Semana',
        cat: 'sanduíches',
    },
    {
        prod: '3 Sabores',
        cat: 'pizzas',
    },
    {
        prod: 'Portuguesa',
        cat: 'pizzas',
    },
    {
        prod: '4 Queijos',
        cat: 'pizzas',
    },
    {
        prod: 'Margherita',
        cat: 'pizzas',
    },
    {
        prod: 'A Moda',
        cat: 'pizzas',
    },
    {
        prod: 'Calabresa',
        cat: 'pizzas',
    },
    {
        prod: 'Napolitana',
        cat: 'pizzas',
    },
    {
        prod: 'Milho com Baco',
        cat: 'pizzas',
    },
    {
        prod: 'Vegetariana',
        cat: 'pizzas',
    },
    {
        prod: 'Coca-Cola',
        cat: 'bebidas',
    },
    {
        prod: 'Fanta',
        cat: 'bebidas',
    },
    {
        prod: 'Suco Natural',
        cat: 'bebidas',
    },
    {
        prod: 'Água Mineral',
        cat: 'bebidas',
    },
    {
        prod: 'Chá Gelado',
        cat: 'bebidas',
    },
    {
        prod: 'Água Tônica',
        cat: 'bebidas',
    },
    {
        prod: 'Suco Del Valle',
        cat: 'bebidas',
    },
    {
        prod: 'Sprite',
        cat: 'bebidas',
    },
    {
        prod: 'Guaraná Antártica',
        cat: 'bebidas',
    },
]

export default optionsData